/* KUTEE' slideshow — soft crossfade between [data-ku-slide] children of a
   [data-ku-slideshow] container (hero + welcome popup). Interval comes from
   data-interval (ms, set by the section's "Seconds per image" setting).

   Optional controls: a sibling [data-ku-slideshow-controls] element (within the
   same section) with [data-ku-slideshow-dot="<index>"] buttons and one
   [data-ku-slideshow-pause] toggle. Dots work even under prefers-reduced-motion
   — only AUTOPLAY is disabled there. Static behavior is preserved with one
   slide or without JS (first slide ships .is-active from Liquid). Autoplay
   pauses while the tab is hidden. Theme Editor: re-inits on section:load,
   stops timers on section:unload. */
(() => {
  const init = () => {
    document.querySelectorAll('[data-ku-slideshow]').forEach((container) => {
      if (container.__kuSlideshowInit) return;
      container.__kuSlideshowInit = true;

      const slides = container.querySelectorAll('[data-ku-slide]');
      if (slides.length < 2) return;

      const scope = container.closest('section, .shopify-section') || document;
      const controls = scope.querySelector('[data-ku-slideshow-controls]');
      const dots = controls ? controls.querySelectorAll('[data-ku-slideshow-dot]') : [];
      const pauseBtn = controls ? controls.querySelector('[data-ku-slideshow-pause]') : null;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const interval = parseInt(container.getAttribute('data-interval'), 10) || 7000;
      let index = 0;
      let timer = null;
      let userPaused = false;
      // Set once a reduced-motion user presses Play: their deliberate choice
      // outranks the ambient preference for the rest of the page life, so
      // start() must not re-apply the reducedMotion gate after tab switches
      // or dot clicks.
      let explicitPlay = false;

      // Deferred slides ship data-src/data-srcset only (zero bandwidth during
      // initial load / LCP). Hydrate swaps the real attributes in.
      const hydrate = (slide) => {
        slide.querySelectorAll('source[data-srcset], img[data-src]').forEach((el) => {
          if (el.dataset.srcset) {
            el.setAttribute('srcset', el.dataset.srcset);
            el.removeAttribute('data-srcset');
          }
          if (el.dataset.src) {
            el.setAttribute('src', el.dataset.src);
            if (el.dataset.sizes) el.setAttribute('sizes', el.dataset.sizes);
            el.removeAttribute('data-src');
          }
        });
      };
      // Load the waiting slides shortly after init — off the critical path,
      // comfortably before the first crossfade (interval >= 3000ms).
      setTimeout(() => slides.forEach(hydrate), 1500);

      const show = (i) => {
        index = i;
        hydrate(slides[i]); // belt-and-braces: never activate an unhydrated slide
        slides.forEach((slide, n) => slide.classList.toggle('is-active', n === i));
        dots.forEach((dot) => {
          const isActive = parseInt(dot.getAttribute('data-ku-slideshow-dot'), 10) === i;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };
      const tick = () => show((index + 1) % slides.length);
      const start = () => {
        if ((reducedMotion && !explicitPlay) || userPaused) return;
        if (!timer) timer = setInterval(tick, interval);
      };
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          show(parseInt(dot.getAttribute('data-ku-slideshow-dot'), 10) || 0);
          stop();
          start(); // restart the countdown from the chosen slide
        });
      });

      if (pauseBtn) {
        if (reducedMotion) {
          // No autoplay to pause — reflect the stopped state.
          userPaused = true;
          pauseBtn.classList.add('is-paused');
          pauseBtn.setAttribute('aria-pressed', 'true');
        }
        pauseBtn.addEventListener('click', () => {
          userPaused = !userPaused;
          pauseBtn.classList.toggle('is-paused', userPaused);
          pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          if (userPaused) {
            stop();
          } else {
            // Explicit play always runs — even under prefers-reduced-motion,
            // a deliberate press outranks the ambient preference.
            explicitPlay = true;
            stop();
            start();
          }
        });
      }

      container.__kuSlideshowStop = stop;
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });
      start();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ku-slideshow]').forEach((container) => {
      if (container.__kuSlideshowStop) container.__kuSlideshowStop();
    });
  });
})();
